const glCodes = 'gl-codes';
const productCodes = 'product-codes';
const creditMemos = 'credit-memos';
const terms = 'terms';

export default {
  glCodes,
  productCodes,
  creditMemos,
  terms,
};
